import standardTreatmentService from "services/StandardTreatment";
import useServiceData from "./useServiceData";

// Sumber dropdown Therapy editor (HANDOFF §6.0 Step 4). Semua status dimuat agar
// terapi lama yang memakai master nonaktif tetap terbaca; pilihan baru hanya aktif.
const useTherapyMasters = () => {
  const drugs = useServiceData(() => standardTreatmentService.listDrugs({ page: 1, limit: 100 }), []);
  const regimens = useServiceData(() => standardTreatmentService.listRegimens({ page: 1, limit: 100 }), []);
  return {
    drugs: drugs.data?.drugs || [],
    regimens: regimens.data?.regimens || [],
    loading: drugs.loading || regimens.loading,
    error: drugs.error || regimens.error,
    reload: () => Promise.all([drugs.reload(), regimens.reload()]),
  };
};

export default useTherapyMasters;
